import { logo } from '../Resources/Images';
import '../Resources/CSS/output.css';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Login from '../Pages/Login/Login';
import { ActionTypes, AppStoreProvider, useAppDispatch, useAppState } from '../Store';
import Dashboard from '../Pages/Dashboard/Dashboard';
import Contacts from '../Pages/Contacts/Contacts';
import Tags from '../Pages/Tags/Tags';
import Contact from '../Pages/Contacts/Contact';
import Automatisations from '../Pages/Automatisations/Automatisations';
import Automatisation from '../Pages/Automatisations/Automatisation';
import Campaigns from '../Pages/Automatisations/Campaigns';
import { Transition } from '@headlessui/react';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Tag from '../Pages/Tags/Tag';
import General from '../Pages/Settings/General';
import CustomFields from '../Pages/Settings/CustomFields';
import Events from '../Pages/Reports/Events';
import APISetting from '../Pages/Settings/APISetting';
import Shopify from '../Pages/Settings/Shopify';
import Apps from '../Pages/Settings/Apps';
import ScheduledTask from '../Pages/ScheduledTask/ScheduledTask';
import GlobalVariable from '../Pages/Settings/GlobalVariable';
import AdminClientConnection from '../Pages/Settings/AdminClientConnection';
import Twilio from '../Pages/Settings/Twilio';
import Documentation from '../Pages/Settings/Documentation';
import Reports from '../Pages/Reports/Reports';
import Report from '../Pages/Reports/Report';
import Board from '../Pages/Reports/Board';
import SetupMFA from '../Pages/Login/SetupMFA';
// Home component
function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

// Main AppContent component that uses the context
function AppContent() {
  const appState = useAppState();
  const dispatch = useAppDispatch();

  console.log(appState.notification);

  return (
    <div className="min-h-screen w-full flex flex-col flex-1">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/setup-totp" element={<SetupMFA />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/tags" element={<Tags />} />
        <Route path="/tag/:tagId" element={<Tag />} />
        <Route path="/contacts/:contactId" element={<Contact />} />
        <Route path="/automatisations" element={<Automatisations />} />
        <Route path="/automatisation/:automatisationId" element={<Automatisation />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaign/:automatisationId" element={<Automatisation isCampaign={true} />} />
        <Route path="/settings" element={<General />} />
        <Route path="/settings/custom-field" element={<CustomFields />} />
        <Route path="/settings/integration" element={<APISetting />} />
        <Route path="/settings/shopify" element={<Shopify />} />
        <Route path="/settings/twilio" element={<Twilio />} />
        <Route path="/settings/apps" element={<Apps />} />
        <Route path="/settings/global-variable" element={<GlobalVariable />} />
        <Route path="/settings/admin" element={<AdminClientConnection />} />
        <Route path="/settings/documentation" element={<Documentation />} />
        <Route path="/events" element={<Events />} />
        <Route path="/scheduled-tasks" element={<ScheduledTask />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/report/:reportId" element={<Report />} />
        <Route path="/board/:boardId" element={<Board />} />
      </Routes>

      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition show={appState.notification?.show}>
            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="shrink-0">
                    {appState.notification?.type === 'success' ? (
                      <CheckCircleIcon aria-hidden="true" className="size-6 text-green-400" />
                    ) : appState.notification?.type === 'warning' ? (
                      <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-yellow-400" />
                    ) : (
                      <ExclamationCircleIcon aria-hidden="true" className="size-6 text-red-400" />
                    )}
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">{appState.notification?.title}</p>
                    <p className="mt-1 text-sm text-gray-500">{appState.notification?.message}</p>
                  </div>
                  <div className="ml-4 flex shrink-0">
                    <button
                      type="button"
                      onClick={() => {
                        dispatch({ type: ActionTypes.SET_NOTIFICATION, payload: { show: false } })
                      }}
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon aria-hidden="true" className="size-5" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <AppStoreProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AppStoreProvider>
  );
}

export default App;
